import './Laws.scss';
import { useIntl } from "react-intl";
import HtmlView from 'component/htmlView/html-view';
import DataNotFound from 'component/shared/DataNotFound/DataNotFound';
import Card from './components/Card';
import { LabelLangString } from 'component/LabelLang/label-lang';
import { useSelector } from 'react-redux';
import ContentLoading from 'component/LoadingComponent/ContentLoading';
import useSWR from 'swr';
import { END_POINTS } from 'constants/APIConstant';
import { useEffect } from 'react';
import ReactGA from "react-ga4";

function Laws() {
  const intl = useIntl();

  const currentLocale = useSelector(({ theme }) => theme.locale);

          
  ReactGA.initialize(END_POINTS.TRACKING_ID);
  
  useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/about/laws-frameworks", title: "About Laws Page" });
  }, []);
  

    // usage_right_term
    const rightTerm = useSWR({
      url: END_POINTS.USAGE_RIGHT_TERM,
    });
  
    // laws
    const lawsList = useSWR({
      url: END_POINTS.LAWS,
    });


  return (
    <ContentLoading isLoading={rightTerm.isLoading || lawsList.isLoading}>
      <div className="laws">
        <div className="row g-5">
          <div className="col-12 col-lg-8">
            <div className="laws-text">
              <h6>{intl.formatMessage({ id: "roles" })}</h6>

              {rightTerm?.data?.data?.value ? (
                <HtmlView 
                    html={
                        LabelLangString({
                          id: "value",
                          currentLocale: currentLocale,
                          defaultValue: rightTerm?.data?.data?.value,
                          translations: rightTerm?.data?.data?.elementTranslations
                        })
                    }
                /> 
              ) : (
                <DataNotFound />
              )}
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="laws-box">
              <h6>{intl.formatMessage({ id: "laws" })}</h6>

              {lawsList?.data?.data && Object.keys(lawsList?.data?.data).length > 0 ? (
                lawsList?.data?.data?.map(({ title, description, url, isPDF, lawRegulationTranslations }, i) => (
                  <Card key={i} url={url} title={title} isPDF={isPDF} description={description} translation={lawRegulationTranslations} />
                ))
              ) : (
                <DataNotFound />
              )}
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Laws